export const API_HOST = process.env.NODE_ENV === 'development' ? 'http://localhost:3999' : 'https://zamowienia.adminbrothers.com'